import angular from 'angular';
import otherFormComponent from './other-form.component';

export default angular.module('components.app.adverseEvent.otherForm', [])
  .component('otherForm', otherFormComponent)
  .value('EventEmitter', payload => ({ $event: payload }))
  .name;



// WEBPACK FOOTER //
// ./components/app/adverse-event/other-form/other-form.module.js